import Dinero from 'dinero.js'
import store from 'state/store'
import { CASH_DRAWER_PAYMENT_METHOD } from 'utils/constants'
import { roundTo } from 'utils/data-manipulation/valueFormatter'
import dayjs from 'dayjs'

const reverseAmount = amount => parseFloat(amount) * -1

const formatAccountTransferPayload = data => {
  const state = store.getState()
  const { defaultCurrency } = state?.settings || {}
  const { fromAccountId, toAccountId, amount, notes, idempotencyKey } = data

  const total = Dinero({
    amount: roundTo(parseFloat(amount) * 100),
    precision: 2,
    currency: defaultCurrency,
  }).toObject()

  return {
    body: {
      transferDate: data?.transferDate || new Date().toISOString(),
      total,
      notes: notes || '',
      fromAccountId,
      toAccountId,
      idempotencyKey,
    },
  }
}

const formatPaymentPayload = data => {
  const { accountId, activityType, amount, notes, idempotencyKey } = data
  const amountTransformed = activityType === 'deposit' ? reverseAmount(amount) * 100 : parseFloat(amount) * 100

  const total = Dinero({
    amount: parseInt(amountTransformed.toFixed(), 10),
    precision: 2,
  }).toObject()

  return {
    paymentCreation: {
      paymentMethod: CASH_DRAWER_PAYMENT_METHOD,
      total,
      accountId,
      paymentNotes: notes,
      paymentDate: data?.paymentDate ? dayjs(data.paymentDate).valueOf() : new Date().getTime(),
      inboundTickets: [],
      idempotencyKey,
    },
  }
}

const formatAccountPayload = data => {
  const state = store.getState()
  const { defaultCurrency } = state?.settings || {}

  const { accountName, ledgerCode, type } = data
  return {
    accountDto: {
      accountName,
      ledgerCode,
      type,
      currency: defaultCurrency,
    },
  }
}

export const formatSettingsBladeData = (action, data) => {
  switch (action) {
    case 'addActivity': {
      if (data.activityType === 'transfer') {
        return formatAccountTransferPayload(data)
      }
      return formatPaymentPayload(data)
    }
    case 'addAccount': {
      return formatAccountPayload(data)
    }
    default:
      return null
  }
}
